


export default {
    PAYSTACK: 'Paystack',
    REMITA: 'Remita',
}
